import { render, staticRenderFns } from "./PropertyStructure.vue?vue&type=template&id=42ad4189&"
import script from "./PropertyStructure.vue?vue&type=script&lang=ts&"
export * from "./PropertyStructure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports